const OrderSummary = ({
  productItems,
  donationItems,
  donationTotal,
  productTotal,
  petProductTotal,
  merchandiseTotal,
  shippingFee,
  total,
}) => {
  const petProductItems =
    productItems?.filter(
      (item) =>
        item.product_id && !item.product_id.toString().startsWith("merch-")
    ) || [];
  const merchandiseItems =
    productItems?.filter(
      (item) =>
        item.product_id && item.product_id.toString().startsWith("merch-")
    ) || [];

  const totalItems = (productItems?.length || 0) + (donationItems?.length || 0);

  return (
    <div
      className="rounded-xl35 p-8 shadow-cartBoxes"
      style={{ backgroundColor: "#1b3a5d" }}
    >
      <h1 className="font-inter text-white text-left !text-2xl !font-light mb-6">
        Order Summary
      </h1>

      <div className="space-y-4">
        <div className="flex flex-row w-full justify-between">
          <span className="text-white text-sm">Total Items</span>
          <span className="text-white text-sm">{totalItems}</span>
        </div>

        {/* Pet Products Subtotal */}
        {petProductItems.length > 0 && (
          <div className="flex flex-row w-full justify-between">
            <span className="text-white text-sm opacity-80">Pet Products</span>
            <span className="text-white text-sm opacity-80">
              ${petProductTotal.toFixed(2)}
            </span>
          </div>
        )}

        {/* Merchandise Subtotal */}
        {merchandiseItems.length > 0 && (
          <div className="flex flex-row w-full justify-between">
            <span className="text-white text-sm opacity-80">Merchandise</span>
            <span className="text-white text-sm opacity-80">
              ${merchandiseTotal.toFixed(2)}
            </span>
          </div>
        )}

        {/* Donations Subtotal */}
        {donationItems?.length > 0 && (
          <div className="flex flex-row w-full justify-between">
            <span className="text-white text-sm opacity-80">Donations</span>
            <span className="text-white text-sm opacity-80">
              ${donationTotal.toFixed(2)}
            </span>
          </div>
        )}

        <div className="flex flex-row w-full justify-between">
          <span className="text-white text-sm">Subtotal</span>
          <span className="text-white text-sm">
            ${(donationTotal + productTotal).toFixed(2)}
          </span>
        </div>

        <div className="flex flex-row w-full justify-between">
          <span className="text-white text-sm">Shipping</span>
          <span className="text-white text-sm">
            ${productItems?.length > 0 ? shippingFee.toFixed(2) : "0.00"}
          </span>
        </div>

        <div className="flex flex-row w-full justify-between">
          <span className="text-white text-sm">Taxes</span>
          <span className="text-white text-sm">$0.00</span>
        </div>

        <hr className="my-4 border-white border-opacity-30" />

        <div className="flex flex-row w-full justify-between">
          <span className="text-white text-lg font-semibold">Total</span>
          <span className="text-white text-lg font-semibold">
            ${total.toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
